import { Link, useLocation } from "react-router-dom";
import { signOut, useSession } from "@/lib/auth-client";

const navLinks = [
  { href: "/dashboard",       label: "Dashboard" },
  { href: "/scan-tag",        label: "Scan Tag" },
  { href: "/check-tag",       label: "Check Tag" },
  { href: "/fudges",          label: "Fudges" },
  { href: "/fudges/history",  label: "History" },
];

const adminLinks = [
  { href: "/admin/tags",      label: "Tags" },
  { href: "/admin/events",    label: "Event Log" },
  { href: "/admin/kks-codes", label: "KKS Codes" },
  { href: "/users",           label: "User Admin" },
  { href: "/admin/database",  label: "Database Admin" },
  { href: "/peers",           label: "Peers" },
];

interface NavProps {
  open: boolean;
  onClose: () => void;
}

export default function Nav({ open, onClose }: NavProps) {
  const { pathname } = useLocation();
  const { data: session } = useSession();

  async function handleSignOut() {
    await signOut();
    window.location.href = "/";
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const isAdmin = (session?.user as any)?.role === "admin";

  function linkClass(href: string) {
    const active = pathname === href || pathname.startsWith(href + "/");
    return `flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors ${
      active ? "bg-slate-700 text-white" : "text-slate-300 hover:bg-slate-700 hover:text-white"
    }`;
  }

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-black/40 z-40 md:hidden" onClick={onClose} />
      )}
      <aside className={`fixed inset-y-0 left-0 z-50 w-56 flex-shrink-0 bg-slate-800 text-white flex flex-col h-full transform transition-transform duration-200 ease-in-out md:static md:translate-x-0 md:z-auto ${open ? "translate-x-0" : "-translate-x-full"}`}>
        <div className="px-4 py-4 border-b border-slate-700 flex items-center gap-3">
          <img src="/logo.jpg" alt="Logo" className="w-8 h-8 rounded object-cover flex-shrink-0" />
          <span className="text-sm font-semibold text-white">Fudge Log</span>
        </div>

        <nav className="flex-1 px-2 py-4 space-y-1 overflow-y-auto">
          {navLinks.map(({ href, label }) => (
            <Link key={href} to={href} className={linkClass(href)} onClick={onClose}>{label}</Link>
          ))}

          {isAdmin && (
            <>
              <p className="px-3 pt-4 pb-1 text-xs font-semibold text-slate-500 uppercase tracking-wider">Admin</p>
              <div className="pl-3 space-y-1">
                {adminLinks.map(({ href, label }) => (
                  <Link key={href} to={href} className={linkClass(href)} onClick={onClose}>{label}</Link>
                ))}
              </div>
            </>
          )}
        </nav>

        <div className="px-4 py-4 border-t border-slate-700">
          {session?.user && (
            <p className="text-xs text-slate-400 truncate mb-2">{session.user.email}</p>
          )}
          <button onClick={handleSignOut}
            className="w-full text-left px-3 py-2 rounded-md text-sm text-slate-300 hover:bg-slate-700 hover:text-white transition-colors">
            Sign out
          </button>
        </div>
      </aside>
    </>
  );
}
